/**
 * North Star's own reads beyond intelligence-routes.ts: the per-facility underwrite the
 * Deal Desk keys off when a building arrives from the Relationship Map or the North Star
 * map (GET /api/financial/facilities/:id/underwrite, src/financial/router.ts).
 */
import { route } from './route';

export interface UnderwriteField {
  value: number | null;
  basis: 'measured' | 'modelled' | null;
  note?: string;
}

/** GET /api/financial/facilities/:id/underwrite (404 answers { error } when not in the catalog). */
export interface FacilityUnderwrite {
  facilityId?: string;
  name?: string;
  ccn?: string;
  state?: string | null;
  fields?: {
    beds: UnderwriteField;
    occupancy: UnderwriteField;
    revenue: UnderwriteField;
    operatingMargin: UnderwriteField;
    ebitda: UnderwriteField;
    latestHcrisYear: number | null;
  };
  hasHcris?: boolean;
  honesty?: string;
  error?: string;
}

export const intelUnderwrite = route<FacilityUnderwrite>()('GET', '/api/financial/facilities/:id/underwrite', { acceptStatuses: [404] });
